import {
  GET_DIVIDED_SUMM_REPORT_FAIL,
  GET_DIVIDED_SUMM_REPORT_REQUEST,
  GET_DIVIDED_SUMM_REPORT_SUCCESS,
  GET_GROUP_SUMM_FAIL,
  GET_GROUP_SUMM_REQUEST,
  GET_GROUP_SUMM_SUCCESS,
  GET_SINGLE_REPORT_FAIL,
  GET_SINGLE_REPORT_REQUEST,
  GET_SINGLE_REPORT_SUCCESS,
  GET_SUMM_REPORT_FAIL,
  GET_SUMM_REPORT_REQUEST,
  GET_SUMM_REPORT_SUCCESS,
} from "src/constants/types";

export const reportReducers = (state = { weight: 0 }, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_SUMM_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SUMM_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        summ_reports: payload,
      };
    case GET_SUMM_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_DIVIDED_SUMM_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_DIVIDED_SUMM_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        divided_summ_reports: payload,
      };
    case GET_DIVIDED_SUMM_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_REPORT_SUCCESS:
      return {
        ...state,
        report_detail: payload,
        loading: false,
      };
    case GET_SINGLE_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_GROUP_SUMM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_GROUP_SUMM_SUCCESS:
      return {
        ...state,
        loading: false,
        group_summ_reports: payload,
      };
    case GET_GROUP_SUMM_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
